<template>
<v-dialog width="1000" v-model="show">
  <slot slot="activator" name="activator">
    <v-btn block color="primary">
      {{ $t('related.update_group_type') }}
    </v-btn>
  </slot>
  <v-card>
    <v-card-title class="headline" primary-title>
      {{ $t('related.update_schema') }} - {{group.name}}
    </v-card-title>
    <v-container>
      <v-form ref="form" v-model="valid" v-on:submit="save">
        <v-flex xs8>
          <v-text-field v-model="name" :rules="nameRules" :label="`${$t('related.group_type')}`" required></v-text-field>
        </v-flex>
        <v-flex xs8>
          <v-select v-model="relatedValues" :items="relatedSchemaValues" :label="`${$t('related.values')}`" multiple chips item-text="name" item-value="id" persistent-hint></v-select>
        </v-flex>
        <v-btn type="submit">
          {{ $t('archive.filter.save') }}
        </v-btn>
      </v-form>
    </v-container>
  </v-card>
</v-dialog>
</template>
<script>
import http from '@/plugins/http'

export default {
  components: {},
  props: ["group"],
  computed: {
    relatedSchemaValues() {
      let valuesType = this.$store.getters.relatedValuesType(this.group["type_id"])
      return valuesType != undefined ? valuesType.values : []
    },
    options() {
      return {
        theme: {
          mode: this.$store.getters.darkTheme ? 'dark' : 'light'
        },
      }
    },
  },
  data() {
    return {
      name: "",
      relatedValues: [],
      nameRules: [
        v => !!v || this.$t('validator.blank'),
        v => (!!v && (v.length <= 100 && v.length > 1)) || this.$t('validator.wrong_length')
      ],
      show: false,
      valid: false
    }
  },
  methods: {
    save(e) {
      e.preventDefault();
      if (this.valid) {
        http.patch('related/group/' + this.group.id, this.getPayload())
          .then(() => {
            this.group.name = this.name
            this.show = false;
            this.showMessage(this.$t('dir.updated'), "success")
          }).catch(() => {
            this.showMessage(this.$t('die.updated_error'), "danger")
          })
      }
    },
    getPayload() {
      let payload = {}
      payload.name = this.name
      payload["related_values_id"] = this.relatedValues
      return payload;
    },
    showMessage(text, color) {
      this.$store.commit("setSnack", {
        message: text,
        color: color,
      })
    }
  },
  created() {
    this.name = this.group.name
    this.relatedValues = this.group.values
  },
  watch: {
    show: function(value) {
      this.$store.dispatch("loadValuesType", {
        idType: this.group["type_id"]
      })
    }
  }
}
</script>

<style>
.loading-circle {
  margin: 20px;
}
</style>
